import { Component } from '@angular/core';
import { Router } from '@angular/router';

import { FirebaseService } from '../../services/firebase.service';
import { SnackBarService } from '../../services/snack-bar.service';

@Component({
	selector    : 'admin',
	templateUrl : 'admin.html',
	styleUrls   : [ 'admin.scss' ]
})

export class AdminComponent {
  feedbacks                     = [];
  admin               : boolean = false;
  forceItemDeptUpdate : boolean = false;
  expandedState       : {}      = {};

	constructor(
    private firebaseService : FirebaseService,
    private snackBarService : SnackBarService,
    private router          : Router
  ) {
    this.initUser();

    firebaseService.feedback.get()
      .subscribe(data => this.feedbacks = data);
  }

  initUser(counter : number = 0) : void {
    if (this.firebaseService.user) {
      this.firebaseService.user
        .subscribe(user => {
          // protect admin page from non-admin users
          if (!user.admin)
            this.router.navigate(['lists']);
          else {
            this.admin = true;
          }
        });
    } else if (counter++ < 100) {
      setTimeout(() => this.initUser(counter), 10);
    }
  }

  toggleResolvedResponded(feedback, resolved : boolean) : void {
    let changes : {} = {};

    if (resolved)
      changes['resolved'] = !feedback.resolved;
    else
      changes['responded'] = !feedback.responded;

    this.firebaseService.feedback.update(feedback, changes);
  }

  adminUpdateStaleUGC() {
    this.firebaseService.admin.update.staleUGC();
  }

  adminUpdateLowercaseItems() {
    this.firebaseService.admin.update.lowercaseItems();
  }

  adminUpdateItemDept() {
    this.firebaseService.admin.update.itemDept(this.forceItemDeptUpdate);
  }
}


// WEBPACK FOOTER //
// /Users/briznad/Documents/WebDev/personal/cartmigo/cartmigo-beta/src/app/components/admin/admin.ts